<template>
    <v-container class="instance-details-container">
        <v-row
            no-gutters
            style="height: 150px;"
        >
            <v-col cols="3">
                <instance-side-bar
                    :instance="instance"
                    @changeCurrentView="changeCurrentView"
                >
                </instance-side-bar>
            </v-col>
            <v-col
                class="instance-details-layout"
            >
                <button
                    @click="$eventBus.$emit('close-instance-details')"
                >
                    <- {{$t('instance.instance_details.instance_leave_details')}}
                </button>
                <h2>
                    {{$t('instance.instance_details.instance_title')}}
                </h2>
                <general-details
                    v-if="currentSideBarView === 0"
                    :instance="instance"
                    :modelisations="modelisations"
                ></general-details>
                <administrator-details
                    v-else-if="currentSideBarView === 1"
                    :instance="instance"
                ></administrator-details>
                <advanced-settings-details
                    v-else-if="currentSideBarView === 2"
                    :instance="instance"
                ></advanced-settings-details>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import InstanceSideBar from './instance-side-bar.vue';
import GeneralDetails from './general-details.vue';
import AdministratorDetails from './administrator-details.vue';
import AdvancedSettingsDetails from './advanced-settings.vue';
export default {

    name: 'index',

    components:{
        InstanceSideBar,
        GeneralDetails,
        AdministratorDetails,
        AdvancedSettingsDetails
    },

    props:{
        instance:{
            type: Object,
            required: true,
        },
        modelisations:{
            type: Array,
            required: true,
        },
    },

    data () {
        return {
            currentSideBarView: 0,
        };
    },
    methods:{
        changeCurrentView(selectedSidebarView){
            this.currentSideBarView = selectedSidebarView;
        }
    }
};
</script>

<style lang="css" scoped>
.instance-details-container{
    margin-left: 0;
    padding-left: 0;
}
.instance-details-layout{
    margin: 2em 1em 1em 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Instance/InstanceDetails/index.vue